import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  ref: "modalRef",
  class: "modal-content neon"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "info-section" }
const _hoisted_4 = { class: "info-section-wrapper" }
const _hoisted_5 = { class: "badge-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "badge darkBadge"
}
const _hoisted_7 = {
  key: 1,
  class: "badge darkBadge"
}
const _hoisted_8 = {
  key: 2,
  class: "badge darkBadge"
}
const _hoisted_9 = {
  key: 3,
  class: "badge darkBadge"
}
const _hoisted_10 = { class: "actions" }
const _hoisted_11 = { class: "btn" }
const _hoisted_12 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_modal_header = _resolveComponent("app-modal-header")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_modal_header, { onClose: _ctx.close }, null, 8, ["onClose"]),
    _createElementVNode("img", {
      src: _ctx.url,
      alt: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.folder)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.folder?.name), 1))
            : _createCommentVNode("", true),
          (_ctx.coloristicType)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.t(_ctx.coloristicType)), 1))
            : _createCommentVNode("", true),
          (_ctx.maskType)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.t(_ctx.maskType)), 1))
            : _createCommentVNode("", true),
          (_ctx.paletteType)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.getPaletteName()), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_app_input, {
          modelValue: _ctx.signIn,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signIn) = $event)),
          icon: ['fas', 'fa-pencil'],
          "is-label": false
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_app_button, {
              severity: "info",
              title: "addFolder",
              onClick: _ctx.openFolderModal
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_app_button, {
              loading: _ctx.isSaveToGallery,
              severity: "warning",
              title: "saveToGallery",
              onClick: _ctx.saveToGallery
            }, null, 8, ["loading", "onClick"])
          ])
        ])
      ])
    ])
  ], 512))
}